import React from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

function LoginMsg({ msg, onClose }) {
  return (
    <Modal
      show={!!msg}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Отримання нового паролю</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>
          {msg}
          {' '}
        </h4>
      </Modal.Body>
      <Modal.Footer>
        <NavLink
          to="/"
        >
          <Button
            variant="primary"
            onClick={() => onClose(false)}
          >
            Закрити
          </Button>
        </NavLink>
      </Modal.Footer>
    </Modal>
  );
}

LoginMsg.propTypes = {
  msg: PropTypes.string,
  onClose: PropTypes.func,

};

LoginMsg.defaultProps = {
  msg: null,
  onClose: () => null,
};

export default LoginMsg;
